import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface ConfirmRowProps {
  amount: number;
  currency: string;
  merchant: string;
  date: string;
  category: string;
  categories: string[];
  saveAsTemplate: boolean;
  onCategoryChange: (category: string) => void;
  onDateChange: (date: string) => void;
  onSaveAsTemplateChange: (checked: boolean) => void;
}

export const ConfirmRow = ({
  amount,
  currency,
  merchant,
  date,
  category,
  categories,
  saveAsTemplate,
  onCategoryChange,
  onDateChange,
  onSaveAsTemplateChange,
}: ConfirmRowProps) => {
  return (
    <div className="space-y-3">
      {/* Amount */}
      <div className="space-y-1">
        <label className="text-xs font-medium text-muted-foreground">Amount</label>
        <p className="text-2xl font-bold text-primary">
          {currency} {amount.toFixed(2)}
        </p>
      </div>

      {/* Merchant */}
      <div className="space-y-1">
        <label className="text-xs font-medium text-muted-foreground">Merchant</label>
        <p className="text-lg font-semibold">{merchant}</p>
      </div>

      {/* Date */}
      <div className="space-y-1">
        <label htmlFor="expense-date" className="text-xs font-medium text-muted-foreground">Date</label>
        <Input
          id="expense-date"
          type="date"
          value={date.includes('T') ? date.split('T')[0] : date}
          onChange={(e) => onDateChange(e.target.value)}
          className="h-10 border-0 bg-muted/50 focus-visible:ring-1"
        />
      </div>

      {/* Category */}
      <div className="space-y-2">
        <label className="text-xs font-medium text-muted-foreground">Category</label>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Button
              key={cat}
              variant={category === cat ? 'default' : 'outline'}
              size="sm"
              onClick={() => onCategoryChange(cat)}
              className="min-h-[36px]"
            >
              {cat}
            </Button>
          ))}
        </div>
      </div>


      {/* Save as Template */}
      <div className="flex items-center space-x-2 pt-2 border-t border-border">
        <Checkbox 
          id="save-template" 
          checked={saveAsTemplate}
          onCheckedChange={onSaveAsTemplateChange}
        />
        <Label 
          htmlFor="save-template" 
          className="text-sm font-medium cursor-pointer"
        >
          Save as quick action template
        </Label>
      </div>
    </div>
  );
};
